import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { isLoggedIn as isLoggedInSelector } from "./services/session/selectors";
import Home from "./screens/Home";
import Login from "./screens/Login";
import Editor from "./screens/Editor";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isLoggedIn = useSelector(isLoggedInSelector);

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const App = () => (
  <Router>
    <Helmet>
      <title>TouchTour360 Editor</title>
    </Helmet>
    <Route exact path="/login" component={Login} />
    <Route exact path="/editor">
      <Redirect to="/" />
    </Route>
    <PrivateRoute exact path="/" component={Home} />
    <PrivateRoute path="/editor/:token" component={Editor} />
  </Router>
);

library.add(fal, fas);

export default App;
